import { DeliveredDutyPreferencesGetResponse } from '@flowio/api-internal-sdk';
import ActionTypes from '../constants/action-types';
import { PropType } from '../../../types';
import {
  ThunkResult,
  ThunkDispatcher,
  RootState,
  ThunkExtraArguments,
} from '../../../stores/types';
import { LegacyResponse } from '../../../utilities/clients/types/server';
import formatErrorResponseV2 from '../../../utilities/format-error-response-v2';
import toLegacyResponse from '../../../utilities/clients/to-legacy-response';

type ResponseType = PropType<DeliveredDutyPreferencesGetResponse, 'body'>;

export default function fetchDeliveredDutyPreference(
  organizationId: string,
  experienceKey: string,
): ThunkResult<Promise<LegacyResponse<ResponseType>>> {
  return (
    dispatch: ThunkDispatcher,
    getState: () => RootState,
    extra: ThunkExtraArguments,
  ): Promise<LegacyResponse<ResponseType>> => {
    dispatch({
      type: ActionTypes.FETCH_DELIVERED_DUTY_PREFERENCE_REQUEST,
    });

    return extra.apiInternal(getState()).deliveeredDutyPreferences.get({
      key: experienceKey,
      organization: organizationId,
    }).then((response) => {
      if (response.ok) {
        dispatch({
          type: ActionTypes.FETCH_DELIVERED_DUTY_PREFERENCE_SUCCESS,
          payload: response.body,
        });
      } else {
        dispatch({
          type: ActionTypes.FETCH_DELIVERED_DUTY_PREFERENCE_FAILURE,
          payload: formatErrorResponseV2(response),
        });
      }
      return toLegacyResponse<ResponseType>(response);
    });
  };
}
